import { Component, computed, inject } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

type NavIndexes = 0 | 1 | 2;

type NavBarState = {
  activeIndex: NavIndexes,
  hidden: false
} | {
  hidden: true
}

class NavBarStateBuilder {
  static withActiveIndex(index: NavIndexes): NavBarState {
    return {
      activeIndex: index,
      hidden: false,
    };
  }

  static hidden(): NavBarState {
    return {
      hidden: true,
    };
  }
}

@Component({
  selector: 'ootd-navbar',
  templateUrl: './navbar.html',
  styleUrls: ['./navbar.less'],
  imports: [ButtonModule, RouterLink]
})
export class NavbarComponent {
  private readonly router = inject(Router);

  private readonly navigationEnd = toSignal(
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event) => event as NavigationEnd)
    )
  );

  protected readonly state = computed<NavBarState>(() => {
    const url = this.navigationEnd()?.urlAfterRedirects ?? this.router.url;

    if (url.includes('premium')) return NavBarStateBuilder.hidden();
    if (url.includes('ranking')) return NavBarStateBuilder.withActiveIndex(0);
    if (url.includes('discover')) return NavBarStateBuilder.withActiveIndex(1);
    if (url.includes('account')) return NavBarStateBuilder.withActiveIndex(2);
    return NavBarStateBuilder.withActiveIndex(1);
  });

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
}
